import React from 'react';

import Head from 'next/head';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import HeroSignup from '@/components/HeroSignup';
import PopularCategoriesStatic from '@/components/PopularCategoriesStatic';
// import Testimonials from '@/components/Testimonials'
import WhoWeAreSignup from '@/components/WhoWeAreSignup';

const Intro = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>

      <link rel="canonical" href="https://callapro.com/signup/" />
    </Head>
    <Header />
    <HeroSignup />
    <WhoWeAreSignup />
    <PopularCategoriesStatic />
    {/*<Testimonials />*/}
    <Footer />
  </div>
);

export default Intro;
